import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block tag-pill border border-foreground-300 text-foreground-600 font-label mb-4">
            全网频道
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            吃瓜分类索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base font-label">
            按圈子追踪，不错过任何黑料
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-white rounded-xl p-5 md:p-6 card-hover border border-background-200/70 transition-all duration-300 hover:bg-primary-500 hover:border-primary-500"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-background-100 flex items-center justify-center mb-4 group-hover:bg-white/20 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-500 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 group-hover:text-white transition-colors text-sm md:text-base mb-1">
                {cat.name}
              </h3>
              <p className="text-foreground-500 text-xs group-hover:text-white/80 transition-colors mb-3 line-clamp-2 font-label">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-primary-500 text-xs font-label group-hover:text-white transition-colors flex items-center gap-1">
                  进入频道
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                </span>
                <span className="text-foreground-400 text-xs font-label group-hover:text-white/60 transition-colors">
                  {cat.count}篇
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}